<template>
  <v-container>
    <span>not Found!</span>
    <router-link to="/">
      Go Back Home
    </router-link>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
